import React, {FC} from 'react';
import {IoMdPaperPlane} from 'react-icons/io';
import {isMasterFirebaseUser} from '../../../../library/GeneralUse';
import {useFirebaseAuthUserStore} from '../../../../stores/FirebaseAuthUserStore';
import {useFirestoreUserStore} from '../../../../stores/FirestoreUserStore';
import {SubmitForm} from '../../../../components/SubmitForm/SubmitForm';
import {SubmitFieldConfig} from '../../../../components/SubmitForm/TYPE_SubmitFieldConfig';

const style = {
	disabledPostSubmitForm: `flex flex-col gap-y-2   p-1 pr-5 recommended:p-4 recommended:pr-8   w-full h-36 recommended:h-48`,
	disabledPostSubmitFormButton: `flex basis-1/6 justify-center items-center   p-2   text-whirlwindLight   bg-whirlwindDisabled   rounded   opacity-65`,
	disabledSubmitFormDummyInput: `flex basis-4/6 justify-center items-center   p-2   text-xl recommended:text-2xl text-whirlwindDisabled   bg-whirlwindDark   border-l-2 border-whirlwindDisabled opacity-65`,
	noFormMessage: `p-4   text-xl recommended:text-2xl text-whirlwindPrimaryLight`,
};

type DisabledPostSubmitFormProps = {
	disabledMessage: string;
};

type PostSubmitFormProps = {
	fields: SubmitFieldConfig[];
	hoursSinceLastPostVal: number;
	onSubmit: () => Promise<void>;
};

const DisabledPostSubmitForm: FC<DisabledPostSubmitFormProps> = ({
	disabledMessage,
}) => {
	return (
		<div
			className={`${style.disabledPostSubmitForm}`}
			data-test-id={`postForm_TEST`}>
			<span className={style.disabledSubmitFormDummyInput}>
				{disabledMessage}
			</span>
			<button
				className={style.disabledPostSubmitFormButton}
				data-test-id={`postFormSubmit_TEST`}
				disabled>
				<IoMdPaperPlane size={40} />
			</button>
		</div>
	);
};

export const PostSubmitForm: FC<PostSubmitFormProps> = ({
	fields,
	onSubmit,
	hoursSinceLastPostVal,
}) => {
	// Zustand
	const firebaseAuthUser = useFirebaseAuthUserStore(
		(state) => state.firebaseAuthUser,
	);
	const firestoreUser = useFirestoreUserStore((state) => state.firestoreUser);

	if (firebaseAuthUser) {
		if (firestoreUser?.username === null) {
			return <DisabledPostSubmitForm disabledMessage={`Set username`} />;
		} else {
			if (isMasterFirebaseUser(firebaseAuthUser.uid)) {
				return (
					<SubmitForm
						fields={fields}
						id={`postForm`}
						onSubmit={onSubmit}
						tailwindcss={`p-1 pr-5 recommended:p-4 recommended:pr-8`}
					/>
				);
			} else if (
				hoursSinceLastPostVal > 24 ||
				isNaN(hoursSinceLastPostVal)
			) {
				return (
					<SubmitForm
						fields={fields}
						id={`postForm`}
						onSubmit={onSubmit}
						tailwindcss={`p-1 pr-5 recommended:p-4 recommended:pr-8`}
					/>
				);
			} else {
				return (
					<DisabledPostSubmitForm
						disabledMessage={`You can post in ${24 - hoursSinceLastPostVal} hours`}
					/>
				);
			}
		}
	} else {
		return (
			<span className={style.noFormMessage}>Sign in to leave a post</span>
		);
	}
};
